customElements.get('product-modal') ||
  customElements.define(
    'product-modal',
    class extends ModalDialog {
      constructor() {
        super();

        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
        this.onThumbClick = this.onThumbClick.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.touchStartX = 0;
        this.touchStartY = 0;
      }

      show(opener) {
        super.show(opener);

        this.openedBy = opener;
        this.dialog = this.querySelector('[role="dialog"]');
        this.content = this.querySelector('.product-media-modal__content--slider');
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        this.prevButton = this.querySelector('[data-media-modal-prev]');
        this.nextButton = this.querySelector('[data-media-modal-next]');
        this.counter = this.querySelector('[data-media-modal-counter]');
        this.thumbButtons = Array.from(this.querySelectorAll('[data-media-modal-thumb]'));

        const activeMediaId = opener?.getAttribute('data-media-id');
        const foundIndex = this.mediaItems.findIndex(
          (item) => item.getAttribute('data-media-id') === activeMediaId
        );

        this.currentIndex = foundIndex > -1 ? foundIndex : 0;

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.onPrevClick);
          this.prevButton.addEventListener('pointerup', this.stopPropagation);
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.onNextClick);
          this.nextButton.addEventListener('pointerup', this.stopPropagation);
        }

        this.thumbButtons.forEach((button) => {
          button.addEventListener('click', this.onThumbClick);
          button.addEventListener('pointerup', this.stopPropagation);
        });

        if (this.dialog) {
          this.dialog.addEventListener('pointerup', this.stopPropagation);
          this.dialog.addEventListener('click', this.stopPropagation);
        }

        if (this.content) {
          this.content.addEventListener('pointerup', this.stopPropagation);
          this.content.addEventListener('click', this.stopPropagation);
          this.content.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.content.addEventListener('touchend', this.onTouchEnd, { passive: true });
        }

        document.addEventListener('keydown', this.onKeydown);

        this.updateActiveMedia();
      }

      hide() {
        if (this.prevButton) {
          this.prevButton.removeEventListener('click', this.onPrevClick);
          this.prevButton.removeEventListener('pointerup', this.stopPropagation);
        }

        if (this.nextButton) {
          this.nextButton.removeEventListener('click', this.onNextClick);
          this.nextButton.removeEventListener('pointerup', this.stopPropagation);
        }

        this.thumbButtons.forEach((button) => {
          button.removeEventListener('click', this.onThumbClick);
          button.removeEventListener('pointerup', this.stopPropagation);
        });

        if (this.dialog) {
          this.dialog.removeEventListener('pointerup', this.stopPropagation);
          this.dialog.removeEventListener('click', this.stopPropagation);
        }

        if (this.content) {
          this.content.removeEventListener('pointerup', this.stopPropagation);
          this.content.removeEventListener('click', this.stopPropagation);
          this.content.removeEventListener('touchstart', this.onTouchStart);
          this.content.removeEventListener('touchend', this.onTouchEnd);
        }

        document.removeEventListener('keydown', this.onKeydown);

        super.hide();
      }

      stopPropagation(event) {
        event.stopPropagation();
      }

      onPrevClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.goTo(this.currentIndex - 1);
      }

      onNextClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.goTo(this.currentIndex + 1);
      }

      onThumbClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const index = parseInt(event.currentTarget.dataset.mediaModalThumb, 10);
        if (!Number.isNaN(index)) {
          this.goTo(index);
        }
      }

      onTouchStart(event) {
        if (!event.touches || event.touches.length !== 1) return;
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      }

      onTouchEnd(event) {
        if (!event.changedTouches || !event.changedTouches.length) return;

        const touchEndX = event.changedTouches[0].clientX;
        const touchEndY = event.changedTouches[0].clientY;
        const diffX = touchEndX - this.touchStartX;
        const diffY = touchEndY - this.touchStartY;

        if (Math.abs(diffX) < 45) return;
        if (Math.abs(diffX) < Math.abs(diffY) * 1.2) return;

        if (diffX < 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }
      }

      goTo(index) {
        if (!this.mediaItems || !this.mediaItems.length) return;

        if (index < 0) index = this.mediaItems.length - 1;
        if (index >= this.mediaItems.length) index = 0;

        this.currentIndex = index;
        this.updateActiveMedia();
      }

      updateActiveMedia() {
        if (!this.mediaItems || !this.mediaItems.length) return;

        this.mediaItems.forEach((item, index) => {
          const isActive = index === this.currentIndex;

          item.classList.toggle('active', isActive);
          item.hidden = !isActive;
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          if (!isActive) {
            const video = item.querySelector('video');
            if (video) video.pause();
          }
        });

        this.thumbButtons.forEach((button, index) => {
          const isActive = index === this.currentIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');

          if (isActive) {
            button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });

        const activeMedia = this.mediaItems[this.currentIndex];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent) {
          activeMedia.loadContent();
        }

        if (this.counter) {
          this.counter.textContent = `${this.currentIndex + 1} / ${this.mediaItems.length}`;
        }
      }
    }
  );